<template>
    <div>
        <h3 class="text-center m-b-30">Sua Foto</h3>

        <div class="account-content">
            <div class="row">
                <div class="col-xs-12">
                    <p class="text-muted m-b-20"><small>Passe um perfume e nos envie uma foto sua. Perfis com fotos tem uma
                        taxa de sucesso até 8 vezes maior. :)</small></p>
                </div>

                <div class="col-xs-12 m-t-30">
                    <input type="file" name="files[]" id="photo_input">
                </div>

                <div class="col-xs-12 m-t-10" v-if="photo_object == null">
                    <p class="text-danger">Inclua uma foto em seu perfil. Isso será muito importante na hora de encontrar um local para alugar pelo WebQuarto.</p>
                </div>
            </div>

            <div class="row m-t-20">
                <div class="col-xs-12">
                    <div class="form-group account-btn text-right">
                        <button @click="goBack" class="btn btn-clear btn-white pull-left">Voltar</button>
                        <button id="submit_button" @click="submit()" class="btn btn-bordered btn-success waves-effect waves-light w-lg ladda-button btn-submit" type="submit">Concluir Perfil</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
require('./../../../../plugins/fileuploader/dist/jquery.fileuploader.min.js');
export default {
    data() {
        return {
            photo_object: null,
        }
    },
    mounted: function () {
        this.startPlugin();
    },
    methods: {
        submit: function () {
            this.$emit('submit');
        },
        goBack: function () {
            this.$emit('goback');
        },
        startPlugin: function () {
            let _this = this;
            // enable fileupload plugin
            var uploader = $('#photo_input').fileuploader({
                limit: 1,
                extensions: ['jpg', 'jpeg', 'png', 'gif'],
                changeInput: ' ',
                theme: 'thumbnails',
                enableApi: true,
                addMore: true,
                files: _this.photo_object,
                thumbnails: {
                    box: '<div class="fileuploader-items">' +
                            '<ul class="fileuploader-items-list">' +
                                '<li class="fileuploader-thumbnails-input"><div class="fileuploader-thumbnails-input-inner"><i>+</i></div></li>' +
                            '</ul>' +
                        '</div>',
                    item: '<li class="fileuploader-item file-has-popup">' +
                            '<div class="fileuploader-item-inner">' +
                                '<div class="type-holder">${extension}</div>' +
                                '<div class="actions-holder">' +
                                    '<a class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i></i></a>' +
                                '</div>' +
                                '<div class="thumbnail-holder">' +
                                    '${image}' +
                                    '<span class="fileuploader-action-popup"></span>' +
                                '</div>' +
                                '<div class="content-holder"><h5>${name}</h5><span>${size2}</span></div>' +
                                '<div class="progress-holder">${progressBar}</div>' +
                            '</div>' +
                        '</li>',
                    item2: '<li class="fileuploader-item file-has-popup">' +
                            '<div class="fileuploader-item-inner">' +
                                '<div class="type-holder">${extension}</div>' +
                                '<div class="actions-holder">' +
                                    '<a href="${file}" class="fileuploader-action fileuploader-action-download" title="${captions.download}" download><i></i></a>' +
                                    '<a class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i></i></a>' +
                                '</div>' +
                                '<div class="thumbnail-holder">' +
                                    '${image}' +
                                    '<span class="fileuploader-action-popup"></span>' +
                                '</div>' +
                                '<div class="content-holder"><h5>${name}</h5><span>${size2}</span></div>' +
                                '<div class="progress-holder">${progressBar}</div>' +
                            '</div>' +
                        '</li>',
                    startImageRenderer: true,
                    canvasImage: false,
                    _selectors: {
                        list: '.fileuploader-items-list',
                        item: '.fileuploader-item',
                        start: '.fileuploader-action-start',
                        retry: '.fileuploader-action-retry',
                        remove: '.fileuploader-action-remove'
                    },
                    onItemShow: function(item, listEl, parentEl, newInputEl, inputEl) {
                        var plusInput = listEl.find('.fileuploader-thumbnails-input'),
                            api = $.fileuploader.getInstance(inputEl.get(0));

                        if(api.getFiles().length >= api.getOptions().limit) {
                            plusInput.hide();
                        }

                        plusInput.insertAfter(item.html);
                        if(item.format == 'image') {
                            item.html.find('.fileuploader-item-icon').hide();
                        }
                    },
                    onItemRemove: function(html, listEl, parentEl, newInputEl, inputEl) {
                        var plusInput = listEl.find('.fileuploader-thumbnails-input'),
                            api = $.fileuploader.getInstance(inputEl.get(0));

                        axios.post('/user/remove-photo').then(function (res) {
                            _this.photo_object = null;
                        });
                        html.children().animate({'opacity': 0}, 200, function() {
                            setTimeout(function() {
                                html.remove();

                                if (api.getFiles().length - 1 < api.getOptions().limit) {
                                    plusInput.show();
                                }
                            }, 100);
                        });
                    }
                },
                afterRender: function(listEl, parentEl, newInputEl, inputEl) {
                    var plusInput = listEl.find('.fileuploader-thumbnails-input'),
                        api = $.fileuploader.getInstance(inputEl.get(0));

                    plusInput.on('click', function() {
                        api.open();
                    });
                },
                upload: {
					url: '/user/upload-photo',
					data: null,
					type: 'POST',
                    enctype: 'multipart/form-data',
					start: true,
					synchron: true,
					beforeSend: function (item) {
                        item.upload.headers = {
                            'X-CSRF-TOKEN': window.Laravel.csrfToken
                        }
                    },
					onSuccess: function(data, item) {
						setTimeout(function() {
							item.html.find('.progress-holder').hide();
							item.renderThumbnail();
                        }, 400);
                        _this.photo_object = item;
					},
					onError: function(item) {
						item.html.find('.progress-holder').hide();
						item.html.find('.fileuploader-item-icon i').text('Failed!');

						setTimeout(function() {
							item.remove();
						}, 1500);
					},
					onProgress: function(data, item) {
						var progressBar = item.html.find('.progress-holder');

						if(progressBar.length > 0) {
							progressBar.show();
							progressBar.find('.fileuploader-progressbar .bar').width(data.percentage + "%");
						}
					}
				},
				dragDrop: {
					container: '.fileuploader-thumbnails-input'
				},
				editor: false,
                captions: {
                    confirm: 'Confirmar',
                    cancel: 'Cancelar',
                    name: 'Nome',
                    type: 'Tipo',
                    size: 'Tamanho',
                    dimensions: 'Dimensões',
                    duration: 'Duração',
                    crop: 'Recortar',
                    rotate: 'Rotacionar',
                    download: 'Download',
                    remove: 'Excluir',
                    drop: 'Arraste os arquivos até aqui para fazer o upload',
                    paste: '<div class="fileuploader-pending-loader"><div class="left-half" style="animation-duration: ${ms}s"></div><div class="spinner" style="animation-duration: ${ms}s"></div><div class="right-half" style="animation-duration: ${ms}s"></div></div> Arrastando um arquivo, clique aqui para cancelar.',
                    removeConfirmation: 'Tem certeza que deseja remover essa foto?',
                    errors: {
                        filesLimit: 'São permitidas até ${limit} fotos em um anúncio.',
                        filesType: 'São permitidos apenas arquivos nestas extensões: ${extensions}.',
                        fileSize: '${name} é muito grande! Selecione uma foto de até ${fileMaxSize}MB.',
                        filesSizeAll: 'Os arquivos que você enviou são muito grandes! Envie fotos de até ${maxSize} MB.',
                        fileName: 'Você já enviou uma foto com o nome ${name}.',
                        folderUpload: 'Você não pode fazer upload de pastas para o WebQuarto.'
                    }
                }
            });

            var api = $.fileuploader.getInstance(uploader);
        }
    }
}
</script>

<style lang="scss">
@import "./../../../../plugins/fileuploader/dist/font/font-fileuploader.css";
@import "./../../../../plugins/fileuploader/dist/jquery.fileuploader.min.css";

.coins-amount {
    font-weight: bolder;
    color: #5f6261;

    img {
        margin-left: 4px;
        width: 14px;
        height: 14px;
    }
}

.fileuploader {
    background: none;
    margin: 0px;
    padding: 0 15px;
}

/* input & items size */
.fileuploader-theme-thumbnails .fileuploader-thumbnails-input,
.fileuploader-theme-thumbnails .fileuploader-items-list .fileuploader-item {
    position: relative;
	display: inline-block;
    padding: 0;
	vertical-align: top;
    width: 25%;
    width: calc(25% - 16px);
    padding-top: 20%;
}

.fileuploader-theme-thumbnails .fileuploader-thumbnails-input-inner,
.fileuploader-theme-thumbnails .fileuploader-item-inner {
    position: absolute;
    top: 0;
    left: 0;
	width: 100%;
	height: 100%;
    border-radius: 6px;
}

/* input */
.fileuploader-theme-thumbnails .fileuploader-thumbnails-input-inner {
    background: #e6ebf4;
    border: 2px dashed #92a7bf;
    text-align: center;
    font-size: 30px;
    color: #90a0bc;
	cursor: pointer;
    opacity: 0.5;
	-webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
	-webkit-transition: all 0.2s ease;
	        transition: all 0.2s ease;
}
.fileuploader-theme-thumbnails .fileuploader-thumbnails-input-inner:hover {
	opacity: 1;
}
.fileuploader-theme-thumbnails .fileuploader-thumbnails-input-inner:active,
.fileuploader-theme-thumbnails .fileuploader-dragging .fileuploader-thumbnails-input-inner {
	background: #f6f6fb;
}
.fileuploader-theme-thumbnails .fileuploader-thumbnails-input-inner i {
    position: absolute;
    font-style: normal;
    left: 0;
    top: 0;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
            transform: translateX(-50%) translateY(-50%);
}

/* items */
.fileuploader-theme-thumbnails .fileuploader-items .fileuploader-items-list {
    margin: -16px 0 0 -16px;
    padding-left: 0;
}
.fileuploader-theme-thumbnails .fileuploader-items .fileuploader-item {
	border-bottom: 0;
}
.fileuploader-theme-thumbnails .fileuploader-items .fileuploader-item:last-child {
    margin-bottom: 0;
}
.fileuploader-theme-thumbnails .fileuploader-items .fileuploader-item-inner {
	background: rgba(0, 0, 0, 0.02);
	overflow: hidden;
	z-index: 1;
}
.fileuploader-theme-thumbnails .fileuploader-item-inner .thumbnail-holder,
.fileuploader-theme-thumbnails .fileuploader-items-list .fileuploader-item-image {
    width: 100%;
	height: 100%;
}
.fileuploader-theme-thumbnails .fileuploader-items-list .fileuploader-item-image {
	position: relative;
	text-align: center;
	overflow: hidden;
}
.fileuploader-theme-thumbnails .fileuploader-items .fileuploader-item .fileuploader-item-icon i {
    display: none;
}
.fileuploader-theme-thumbnails .fileuploader-items .fileuploader-item .fileuploader-action-popup {
    border-radius: 6px;
    z-index: 1;
}
.fileuploader-theme-thumbnails .fileuploader-item .type-holder {
    position: absolute;
    top: 6px;
    left: 6px;
    padding: 4px 6px;
    background: rgba(0, 0, 0, 0.4);
    text-transform: uppercase;
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
    z-index: 2;
}
.fileuploader-theme-thumbnails .fileuploader-item .actions-holder {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 2;
    height: 20px;
}
.fileuploader-theme-thumbnails .fileuploader-items .fileuploader-item .fileuploader-action {
    color: #fff;
    text-shadow: 1px 1px 3px rgba(0,0,0,0.3);
}
.fileuploader-theme-thumbnails .fileuploader-items .fileuploader-item .fileuploader-action + .fileuploader-action {
    margin-left: 8px;
}
.fileuploader-theme-thumbnails .fileuploader-item .content-holder {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 6px;
    text-shadow: 1px 1px 3px rgba(0,0,0,0.3);
    background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 100%);
       background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.65) 100%);
            background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 100%);
    z-index: 2;
}
.fileuploader-theme-thumbnails .fileuploader-item .content-holder h5 {
    display: block;
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.fileuploader-theme-thumbnails .fileuploader-item .content-holder span {
    display: block;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.8);
}

/* uploading */
.fileuploader-theme-thumbnails .fileuploader-items .fileuploader-item.upload-failed .fileuploader-item-inner {
	background: #db6868;
}
.fileuploader-theme-thumbnails .fileuploader-item .progress-holder {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
    background: #fff;
    display: none;
    z-index: 1;
}
.fileuploader-theme-thumbnails .fileuploader-item .progress-holder .fileuploader-progressbar {
	position: relative;
    top: 50%;
	width: 80%;
    height: 6px;
	margin: 0 auto;
    margin-top: -6px;
	background: #dde4f6;
}

/* sorter */
.fileuploader-theme-thumbnails .fileuploader-items .fileuploader-item.sorting {
    padding-top: 0;
    margin: 0;
}
.fileuploader-theme-thumbnails .fileuploader-sorter-placeholder {
    background: #f0f3f9;
    border-radius: 6px;
}

/* responsive */
@media all and (max-width: 768px) {
    .fileuploader-theme-thumbnails .fileuploader-thumbnails-input,
    .fileuploader-theme-thumbnails .fileuploader-items-list .fileuploader-item {
        width: 33.33333333%;
        width: calc(33.33333333% - 16px);
        padding-top: 30%;
    }
}
@media all and (max-width: 480px) {
    .fileuploader-theme-thumbnails .fileuploader-thumbnails-input,
    .fileuploader-theme-thumbnails .fileuploader-items-list .fileuploader-item {
        width: 50%;
        width: calc(50% - 16px);
        padding-top: 40%;
    }
}

</style>